import { PersonRounded, SupportAgentRounded } from '@mui/icons-material';
import { alpha, Avatar } from '@mui/material';
import { ConversationMessageActor } from 'v2/core/entities/feedback/content';

interface ConversationMessageAvatarProps {
  actor: ConversationMessageActor;
}

export const ConversationMessageAvatar = ({
  actor,
}: ConversationMessageAvatarProps) => {
  return (
    <Avatar
      sx={{
        width: '36px',
        height: '36px',
        backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.1),
      }}
    >
      {actor === 'User' ? (
        <PersonRounded
          sx={{
            color: 'text.disabled',
          }}
        />
      ) : (
        <SupportAgentRounded
          sx={{
            color: 'text.disabled',
          }}
        />
      )}
    </Avatar>
  );
};
